var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group form-group--help-block" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { class: `col-sm-${_vm.component.size}` }, [
        !_vm.component.hideLabel
          ? _c("label", [_vm._v(_vm._s(_vm.component.label))])
          : _vm._e(),
        _vm.component.description
          ? _c("span", { staticClass: "help-block" }, [
              _vm._v(_vm._s(_vm.component.description)),
            ])
          : _vm._e(),
        _vm.component.data.currentValue
          ? _c("p", {
              staticClass: "lead",
              domProps: { innerHTML: _vm._s(_vm.component.data.currentValue) },
            })
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }